<template>    
    <div class="row g-3 mb-2">
        <div class="col-12 col-sm-4">
            <Popper :content="errors.shipping_forename" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_forename ? true : false">
                <div class="form-floating">
                    <Field id="shipping_forename" name="shipping_forename" type="text" placeholder="First Name" class="form-control"/>
                    <label for="shipping_forename">Forename</label>
                </div>
            </Popper>
        </div>
        <div class="col-12 col-sm-4">
            <Popper :content="errors.shipping_surname" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_surname ? true : false">
                <div class="form-floating">
                    <Field id="shipping_surname" name="shipping_surname" type="text" placeholder="Last Name" class="form-control"/>
                    <label for="shipping_surname">Surname</label>
                </div>
            </Popper>
        </div>
        <div class="col-12 col-sm-4">
            <Popper :content="errors.shipping_postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_postcode ? true : false">
                <div class="form-floating">
                    <Field id="shipping_postcode" name="shipping_postcode" type="text" placeholder="Postcode" class="form-control" @keyup="this.$parent.$parent.$parent.postcodeLookup($event.target.value, false)"/>
                    <label for="shipping_postcode">Postcode</label>
                </div>
            </Popper>
        </div>
        <div class="col-12 col-sm-4">
            <Popper :content="errors.shipping_address" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_address ? true : false">
                <div class="form-floating">
                    <Field v-slot="{ value }" id="shipping_address" name="shipping_address" as="select" class="form-select">
                        <option value="" disabled>Please select your address</option>
                        <template v-for="address, key in addresses">
                            <template v-if="key != 0">
                                <option :key="key" :value="key" :selected="value && value.includes(address)">{{ address }}</option>
                            </template>
                        </template>
                    </Field>
                    <label for="shipping_address">Address</label>
                </div>
            </Popper>
        </div>
        <div class="col-12 col-sm-4 d-flex align-items-center">
            <label for="input_shipping_address_manually" class="d-inline-block cursor-pointer" >
                Input address manually?
                <Field type="checkbox" id="input_shipping_address_manually" name="input_shipping_address_manually" class="d-inline-block ms-2 cursor-pointer" :value="true" v-model="inputShippingAddressManually" @click="this.$emit('inputShippingAddressManually')"/>
            </label>
        </div>
        <div class="col-12" v-if="inputShippingAddressManually == true">
            <div class="row g-3">
                <div class="col-12 col-sm-4">
                    <Popper :content="errors.shipping_address1" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_address1 ? true : false">
                        <div class="form-floating">
                            <Field id="shipping_address1" name="shipping_address1" type="text" placeholder="Address 1" class="form-control" />
                            <label for="shipping_address1">Address 1</label>
                        </div>
                    </Popper>
                </div>
                <div class="col-12 col-sm-4">
                    <Popper :content="errors.shipping_address2" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_address2 ? true : false">
                        <div class="form-floating">
                            <Field id="shipping_address2" name="shipping_address2" type="text" placeholder="Address 2" class="form-control" />
                            <label for="shipping_address2">Address 2</label>
                        </div>
                    </Popper>
                </div>
                <div class="col-12 col-sm-4">
                    <Popper :content="errors.shipping_address3" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_address3 ? true : false">
                        <div class="form-floating">
                            <Field id="shipping_address3" name="shipping_address3" type="text" placeholder="Address 3" class="form-control" />
                            <label for="shipping_address3">Address 3</label>
                        </div>
                    </Popper>
                </div>
                <div class="col-12 col-sm-4">
                    <Popper :content="errors.shipping_town" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_town ? true : false">
                        <div class="form-floating">
                            <Field id="shipping_town" name="shipping_town" type="text" placeholder="Town" class="form-control" />
                            <label for="shipping_town">Town</label>
                        </div>
                    </Popper>
                </div>
                <div class="col-12 col-sm-4">
                    <Popper :content="errors.shipping_county" arrow placement="top" class="w-100 m-0 border-0" :show="errors.shipping_county ? true : false">
                        <div class="form-floating">
                            <Field id="shipping_county" name="shipping_county" type="text" placeholder="County" class="form-control" />
                            <label for="shipping_county">County</label>
                        </div>
                    </Popper>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    export default {
        props: ['sessionPostcode', 'addresses', 'errors'],
        components: { Field, ErrorMessage },
        data() {
            return {
                inputShippingAddressManually: false
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
<style lang="scss" scoped>

</style>